module.exports = __webpack_public_path__ + "static/img/device_icon1.220658d2.svg";